import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    TransformResponse
} from './transform';

import {
    addActionECW as addPatientGlobalSearchECW,
    setSpin,
} from 'one-state-patient-global-search';
import {format} from 'one-util-date';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction as lookupErrorSet,
} from "one-state-subjecterror/src/action";

export const enum Types {
    SEARCH_ECW = 'one-state-patient-global-search/search-ecw',
    ADD_ECW = 'one-state-patient-global-search/add-ecw',
    PushDatatoSubject = 'one-state-subject/set',
}


const pushToSetPatientGlobalSearch = (payload: any) => addPatientGlobalSearchECW(payload);

/**
 * This Function fetches data from getpatientsearchglobal api
 * @param context contains settings.json etc...
 */
export const fetchPatientsGlobalSearchECW = (context: any) => (
    (action$: ActionsObservable<any>) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            alertnotification,
            settings:
            {
                servers, compatible, ecwendpoints: { getpatientecw }
            }
        } = context;
        const { finesse_proxy_service } = compatible;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.SEARCH_ECW),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient global search request
                 */

                const dataresponse: any = action.payload;
                log.debug("one-athena", "patient-global-search request", dataresponse);
                const getCallerDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.append("Accept", "application/json");
                    headers.append("Content-Type", "text/plain");

                    let data:any = {};
                    if(data) {
                        data = {
                            "PatientID": payload.id ? payload.id : "",
                            "Name": payload.name ? payload.name : "",
                            "dob": payload.birthdate ? payload.birthdate : "",
                            "PhoneNumber": payload.phone ? payload.phone : ""
                        }
                    }
                    let response;
                    if (finesse_proxy_service) {
                        //response = InvokeFinesseProxy(patientsearch, data, locations, log, 'POST', alertnotification);

                    } else {
                        response = server.post({
                            path: getpatientecw,
                            data: data,
                            headers: headers
                        }).then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error("one-athena", "patient-global-search-athena Error", responseresult);
                                let pgserror: ErrorObject = {
                                    source: "Patient Global Search",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return pgserror;
                            })
                        log.debug("one-athenas", "patient-global-search-athena response", response);
                    }
                    return from(response);
                }
                return getCallerDetails(dataresponse).pipe(
                    map(response => TransformResponse(response, context))
                ).pipe(
                    flatMap(response => {
                        const payloadPhone = dataresponse.phone ? dataresponse.phone.replace(/\D/g, '') : null;
                        const responseData = response.subjectdata.map((subject: any) => {
                            subject.phone = subject.contact_formatted ?  subject.contact_formatted: ""
                            return subject
                        })
                        const actions: any = [
                            pushToSetPatientGlobalSearch(responseData)
                        ];
                        // check for error messages.
                        if (response.error) {
                            actions.push(addAction(response.error));
                            //To store the error object in the reducer.
                            actions.push(lookupErrorSet(response.error));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Fuction will stop spinner for 
 * patient global search athena redux action
 * @param context contains the settings,logger etc..
 */
export const resetSpinForPateintGlobalSearchecw = (context: any) => (
    (action$: any) => {
        const { log} = context;
        log.debug(
            "ccw-gadget,patient-global-search-athena",
            "setSpin-patient-global-search-athena", {
            });
        return action$.pipe(
            ofType(Types.ADD_ECW),
            map(action => setSpin(false))
        )
    }
);
